<app-help [link]="bookMeeting" [type]="'lp'"></app-help>
<div class="container-fluid" style="padding-left: 0">
  <div class="row">
    <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8 box-col-12">
      <div class="card">
        <div class="card-header p-b-0">
          <div class="d-flex align-items-baseline">
            <i class="icofont icofont-abacus-alt" style="font-size: 18px"></i>
            <h4 class="ps-2 m-r-5 m-b-0">
              {{ "location.promote.title" | translate }}
            </h4>
          </div>
        </div>
        <div class="card-body">
          <app-video-guidelines-and-upload
            [note]="'location.promote.franchise.note'"
            (emitFileName)="catchFileName($event)"
          ></app-video-guidelines-and-upload>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4 box-col-12">
      <h4>{{ "location.promote.preview" | translate }}</h4>
      <hr />
      <div class="col-6 col-lg-9 col-xxl-6" style="margin: auto">
        <app-ad-video-preview></app-ad-video-preview>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div
    class="card p-3 col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8 box-col-12"
  >
    <div class="card-header p-b-0 pt-2">
      <h4>{{ "location.promote.franchise.locations" | translate }}</h4>
    </div>
    <hr class="m-0" />
    <div class="card-body">
      <div class="d-flex flex-wrap">
        <div *ngFor="let option of options; let i = index">
          <div class="form-check checkbox checkbox-primary mb-0 m-r-30">
            <input
              [id]="option.id"
              type="checkbox"
              name="rdo-ani"
              class="form-check-input"
              [checked]="selectedOption === option.id"
              (click)="save($event, option.id)"
            />
            <label class="form-check-label label" [for]="option.id">{{
              option.value | translate
            }}</label>
          </div>
        </div>
      </div>

      <div class="d-flex flex-wrap mt-3">
        <div *ngFor="let item of listFranchised">
          <span
            class="m-r-10 cursor-pointer"
            [ngClass]="
              'badge ' +
              badgeService.getPromoteOptionsStatus(
                selectedOption,
                this.isItemIncluded(item)
              )
            "
            (click)="choseAction(item)"
          >
            <i
              *ngIf="
                selectedOption === promoteOptions.CUSTOMIZED &&
                !this.isItemIncluded(item)
              "
              (click)="addLocation(item)"
              class="icofont icofont-plus me-1 cursor-pointer"
            ></i>
            <i
              *ngIf="
                selectedOption === promoteOptions.CUSTOMIZED &&
                this.isItemIncluded(item)
              "
              (click)="removeLocation(item)"
              class="icofont icofont-minus me-1 cursor-pointer"
            ></i>
            {{ item }}
          </span>
        </div>
      </div>
    </div>
    <div class="mt-2">
      <div style="display: flex; justify-content: end" class="m-t-10">
        <button
          class="btn btn-primary"
          (click)="onSubmit()"
          [disabled]="selectedFranchised.length === 0 || !filename || loading"
        >
          <loading-button
            [loading]="loading"
            [value]="'buttons.confirm' | translate"
            [icon]="null"
          ></loading-button>
        </button>
      </div>
    </div>
  </div>
</div>
